
import ApiGenericServicesData from 'services/ApiGenericServicesData';

export default class SolicitudesDeEmpadronamiento extends ApiGenericServicesData{
    constructor(){
        super("solicitudesDeEmpadronamiento");
    }
    solicitudes() { return this.customGET("solicitudes"); }  
    openFile(data) { return this.customGET("openFile/"+data.document+"/"+data.id);    }    
    usuariosGeo() { return this.customGET("usuariosGeo"); }
    validarEmpadronado(cui) { return this.customGET("validarEmpadronado/"+cui); }
    exportarExcel(data) { return this.customGET("exportarExcel/"+data.page+"/"+data.pageSize); }
    descargarPdfSolicitudDeRenap(data) { return this.customGET("descargarPdfSolicitudDeRenap/"+data.nroSolicitudRenap+"/"+data.cui); }
    listConteoSolicitudes() { return this.customGET("listConteoSolicitudes"); }  
}